import React from 'react'
import Logo from '../Images/Google-logo.png'
import Kaku from '../Images/Kaku.jpg'
import { Link } from 'react-router-dom'
import './ScheduleStyle.css'
import Navbar from '../HomeComponents/Navbar'

export default function DaySchedule() {
    return (
        <>
            <Navbar/>


            <div className="main-section">
                <div className="day-sidebar">
                    <p className="sidebar-content">
                        It's Daytime
                    </p>
                </div>
                <div className="schedule-container">
                    <div className="schedule-text">
                        <div className="schedule-title">Pick the Day</div>
                        <p className="schedule-subtitle">You can go back and choose whatever day u want</p>
                    </div>



                    <div className="class-container">


                        <div className="class-box-day">
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Monday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Tuesday </h1>
                            </div></Link>

                        </div>
                        <div className="class-box-day">
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Wednesday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Thursday </h1>
                            </div></Link>

                        </div>
                        <div className="class-box-day">
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Friday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Saturday </h1>
                            </div></Link>

                        </div>

                        <div className="class-box">
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Monday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Tuesday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Wednesday </h1>
                            </div></Link>
                        </div>
                        <div className="class-box">
                        <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Thursday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Friday </h1>
                            </div></Link>
                            <Link to="/fetch"> <div className="day-classes">
                                <h1 className="class-title">Saturday </h1>
                            </div></Link>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
